// 主布局：固定 240px 左侧 + 弹性主区域；滚动只发生在右侧内容区。

import type { ReactNode } from "react";
import { Sidebar } from "./Sidebar";

export function Layout({ children }: { children: ReactNode }) {
  return (
    <div className="grid h-screen grid-cols-[240px_1fr] overflow-hidden">
      <Sidebar />
      <main className="min-w-0 overflow-auto p-6">{children}</main>
    </div>
  );
}
